var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      ref: "root",
      staticClass: "sip-time-picker",
      class: { "is-open": _vm.open },
    },
    [
      _c(
        "div",
        {
          staticClass: "sip-time-picker__bar",
          attrs: { role: "group", "aria-label": "Time" },
        },
        [
          _c(
            "button",
            {
              staticClass: "sip-time-picker__clock-btn",
              class: { "is-active": _vm.open },
              attrs: {
                type: "button",
                "aria-expanded": _vm.open ? "true" : "false",
                "aria-haspopup": "dialog",
                title: _vm.trans("general.select") || "Pick time",
              },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.toggleClock.apply(null, arguments)
                },
              },
            },
            [
              _c("em", {
                staticClass: "icon ni ni-clock",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass:
                "custom-select sip-time-picker__field sip-time-picker__field--hour",
              attrs: { name: "hour", "aria-label": "Hour" },
              domProps: { value: _vm.hour },
              on: { change: _vm.updateHour },
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v(_vm._s(_vm.trans("general.select_hour"))),
              ]),
              _vm._v(" "),
              _vm._l(_vm.hours, function (hr) {
                return _c(
                  "option",
                  { key: "h" + hr, domProps: { value: hr } },
                  [_vm._v(_vm._s(_vm.timePadding(hr)))]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "span",
            {
              staticClass: "sip-time-picker__sep",
              attrs: { "aria-hidden": "true" },
            },
            [_vm._v(":")]
          ),
          _vm._v(" "),
          _c(
            "select",
            {
              staticClass:
                "custom-select sip-time-picker__field sip-time-picker__field--minute",
              attrs: { name: "minute", "aria-label": "Minute" },
              domProps: { value: _vm.minute },
              on: { change: _vm.updateMinute },
            },
            [
              _c("option", { attrs: { value: "" } }, [
                _vm._v(_vm._s(_vm.trans("general.select_minute"))),
              ]),
              _vm._v(" "),
              _vm._l(_vm.mins, function (min) {
                return _c(
                  "option",
                  { key: "m" + min, domProps: { value: min } },
                  [_vm._v(_vm._s(_vm.timePadding(min)))]
                )
              }),
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sip-time-picker__meridiem",
              attrs: { role: "group", "aria-label": "AM/PM" },
            },
            [
              _c(
                "button",
                {
                  staticClass: "sip-time-picker__meridiem-btn",
                  class: { "is-active": _vm.normalizedMeridiem === "am" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setMeridiem("am")
                    },
                  },
                },
                [_vm._v("AM")]
              ),
              _vm._v(" "),
              _c(
                "button",
                {
                  staticClass: "sip-time-picker__meridiem-btn",
                  class: { "is-active": _vm.normalizedMeridiem === "pm" },
                  attrs: { type: "button" },
                  on: {
                    click: function ($event) {
                      return _vm.setMeridiem("pm")
                    },
                  },
                },
                [_vm._v("PM")]
              ),
            ]
          ),
        ]
      ),
      _vm._v(" "),
      _vm.open
        ? _c(
            "div",
            {
              staticClass: "sip-time-picker__popover",
              attrs: { role: "dialog", "aria-label": "Clock" },
              on: {
                click: function ($event) {
                  $event.stopPropagation()
                },
              },
            },
            [
              _c("div", { staticClass: "sip-time-picker__popover-head" }, [
                _c(
                  "button",
                  {
                    staticClass: "sip-time-picker__display-part",
                    class: { "is-active": _vm.clockMode === "hour" },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.clockMode = "hour"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.displayHour))]
                ),
                _vm._v(" "),
                _c("span", { staticClass: "sip-time-picker__display-sep" }, [
                  _vm._v(":"),
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sip-time-picker__display-part",
                    class: { "is-active": _vm.clockMode === "minute" },
                    attrs: { type: "button" },
                    on: {
                      click: function ($event) {
                        _vm.clockMode = "minute"
                      },
                    },
                  },
                  [_vm._v(_vm._s(_vm.displayMinute))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "sip-time-picker__popover-meridiem" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "sip-time-picker__meridiem-btn",
                        class: { "is-active": _vm.normalizedMeridiem === "am" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.setMeridiem("am")
                          },
                        },
                      },
                      [_vm._v("AM")]
                    ),
                    _vm._v(" "),
                    _c(
                      "button",
                      {
                        staticClass: "sip-time-picker__meridiem-btn",
                        class: { "is-active": _vm.normalizedMeridiem === "pm" },
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            return _vm.setMeridiem("pm")
                          },
                        },
                      },
                      [_vm._v("PM")]
                    ),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "sip-time-picker__face",
                  on: {
                    mousedown: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "svg",
                    {
                      staticClass: "sip-time-picker__svg",
                      attrs: { viewBox: "0 0 240 240", "aria-hidden": "true" },
                    },
                    [
                      _c("circle", {
                        staticClass: "sip-time-picker__dial",
                        attrs: { cx: "120", cy: "120", r: "110" },
                      }),
                      _vm._v(" "),
                      _c("line", {
                        staticClass: "sip-time-picker__hand",
                        attrs: {
                          x1: "120",
                          y1: "120",
                          x2: _vm.hand.x,
                          y2: _vm.hand.y,
                        },
                      }),
                      _vm._v(" "),
                      _c("circle", {
                        staticClass: "sip-time-picker__hub",
                        attrs: { cx: "120", cy: "120", r: "5" },
                      }),
                      _vm._v(" "),
                      _vm._l(_vm.faceTicks, function (tick) {
                        return _c(
                          "g",
                          {
                            key: _vm.clockMode + "-" + tick.value,
                            staticClass: "sip-time-picker__tick",
                            class: { "is-active": tick.active },
                            on: {
                              click: function ($event) {
                                return _vm.pickTick(tick.value)
                              },
                            },
                          },
                          [
                            _c("circle", {
                              staticClass: "sip-time-picker__tick-dot",
                              attrs: { cx: tick.x, cy: tick.y, r: "16" },
                            }),
                            _vm._v(" "),
                            _c(
                              "text",
                              {
                                staticClass: "sip-time-picker__tick-label",
                                attrs: {
                                  x: tick.x,
                                  y: tick.y,
                                  "dominant-baseline": "central",
                                  "text-anchor": "middle",
                                },
                              },
                              [_vm._v(_vm._s(tick.label))]
                            ),
                          ]
                        )
                      }),
                    ],
                    2
                  ),
                ]
              ),
              _vm._v(" "),
              _c("div", { staticClass: "sip-time-picker__popover-foot" }, [
                _c(
                  "button",
                  {
                    staticClass: "sip-time-picker__link",
                    attrs: { type: "button" },
                    on: { click: _vm.setNow },
                  },
                  [_vm._v("Now")]
                ),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "sip-time-picker__done",
                    attrs: { type: "button" },
                    on: { click: _vm.closeClock },
                  },
                  [_vm._v("Done")]
                ),
              ]),
            ]
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }